import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
    private _auths: AuthService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('X-Skip-Auth')) {
      const modified = request.clone({
        headers: request.headers.delete('X-Skip-Auth')
      });
      return next.handle(modified);
    }

    if (this._auths.token) {
      const modified = request.clone({
        setHeaders: { "Authorization": `Bearer ${this._auths.token}` }
      });
      return next.handle(modified);
    }
    return next.handle(request);
  }
}
